import { CommandCard } from "./CommandCard"
import { CommandSnippet } from "./CommandSnippet"

export type { CommandCardProps, CommandSnippetProps } from "./Code.types"

export const Code = {
  CommandCard,
  CommandSnippet
}
